import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getParams } from '../common/common.func';
import { PagedList } from '../common/common.types';
import { PriceMatrix, PriceMatrixFilter, PriceMatrixSummary, PriceMatrixWM, Quote, QuoteRequest } from './price-matrix.types';

@Injectable()
export class PriceMatrixService {
	private priceMatricesUrl = 'api/priceMatrices';

	constructor(private _http: HttpClient) { }

	getPriceMatrices(filter?: PriceMatrixFilter): Promise<PagedList<PriceMatrixSummary>> {
		const options = { params: getParams(filter) };
		return this._http.get<PagedList<PriceMatrixSummary>>(this.priceMatricesUrl, options).toPromise();
	}

	getPriceMatrix(priceMatrixId: number): Promise<PriceMatrix> {
		return this._http.get<PriceMatrix>(`${this.priceMatricesUrl}/${priceMatrixId}`).toPromise();
	}

	createPriceMatrix(newPriceMatrix: PriceMatrixWM): Promise<number> {
		return this._http.post<number>(this.priceMatricesUrl, newPriceMatrix).toPromise();
	}

	updatePriceMatrix(priceMatrixId: number, updatedPriceMatrix: PriceMatrixWM): Promise<void> {
		return this._http.put<void>(`${this.priceMatricesUrl}/${priceMatrixId}`, updatedPriceMatrix).toPromise();
	}

	activatePriceMatrix(priceMatrixId: number): Promise<void> {
		return this._http.put<void>(`${this.priceMatricesUrl}/${priceMatrixId}/Status/Active`, null).toPromise();
	}

	archivePriceMatrix(priceMatrixId: number): Promise<void> {
		return this._http.delete<void>(`${this.priceMatricesUrl}/${priceMatrixId}`).toPromise();
	}

	getInitialQuotes(priceMatrixId: number) {
		return this._http.get<Quote[]>(`${this.priceMatricesUrl}/${priceMatrixId}/Quotes`)
			.toPromise();
	}

	getQuote(priceMatrixId: number, quoteRequest: QuoteRequest) {
		return this._http.post<Quote>(`${this.priceMatricesUrl}/${priceMatrixId}/Quotes`, quoteRequest).toPromise();
	}
}
